import { render, staticRenderFns } from "./Promocodes.vue?vue&type=template&id=b1186ff6&"
import script from "./Promocodes.vue?vue&type=script&lang=js&"
export * from "./Promocodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1186ff6')) {
      api.createRecord('b1186ff6', component.options)
    } else {
      api.reload('b1186ff6', component.options)
    }
    module.hot.accept("./Promocodes.vue?vue&type=template&id=b1186ff6&", function () {
      api.rerender('b1186ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promocodes/Promocodes.vue"
export default component.exports